module.exports = __webpack_public_path__ + "static/img/fascia_max.9aa249db.png";